import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import classes from './Layout.module.css';
import Toolbar from '../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../components/Navigation/SideDrawer/SideDrawer';
import { PATHNAMES } from '../App';

export const WebsiteContext = React.createContext({ siteName: "Setup's Projects" });

function Layout() {
  const location = useLocation();
  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const [siteName, setSiteName] = useState("Setup's Projects");

  useEffect(() => {
    let name;
    switch (location.pathname) {
      case PATHNAMES.HOME:
        name = "Setup's Projects";
        break;
      case PATHNAMES.FINANCING:
        name = 'Financing';
        break;
      case PATHNAMES.PIXELMIXER:
        name = 'Overwatch Pixel Mixer';
        break;
      case PATHNAMES.CUTEMIXER:
        name = 'Overwatch Cute Mixer';
        break;
      case PATHNAMES.PHARMERCYBIRD:
        name = 'Pharmercybird';
        break;
      default:
        name = "Setup's Projects";
        break;
    }
    setSiteName(name);
  }, [location.pathname]);

  const sideDrawerClosedHandler = useCallback(() => {
    setShowSideDrawer(false);
  }, []);

  const sideDrawerToggleHandler = useCallback(() => {
    setShowSideDrawer((prev) => !prev);
  }, []);

  return (
    <WebsiteContext.Provider value={{ siteName }}>
      <div className={classes.container}>
        <Toolbar drawerToggleClicked={sideDrawerToggleHandler} />
        <SideDrawer open={showSideDrawer} closed={sideDrawerClosedHandler} />
        <main className={classes.Content}>
          <Outlet />
        </main>
      </div>
    </WebsiteContext.Provider>
  );
}

export default Layout;
